import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";
import ThemeModeModule from "@/store/modules/ThemeModeModule";
import HeaderMenuModule from "@/store/modules/HeaderMenuModule";
import ProfileModule from "@/store/modules/ProfileModule";
import OverviewModule from "@/store/modules/OverviewModule";
import PaymentModule from "@/store/modules/PaymentModule";
import JobModule from "@/store/modules/JobModule";
import AvailableJobModule from "@/store/modules/AvailableJobModule";
import ProductModule from "@/store/modules/ProductModule";
import ExpertiseModule from "@/store/modules/ExpertiseModule";
import CountryModule from "@/store/modules/CountryModule";
import UploadFileModule from "@/store/modules/UploadFileModule";
import FirebaseModule from "@/store/modules/FirebaseModule";

config.rawError = true;

const store = createStore({
  modules: {
    AuthModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    ThemeModeModule,
    HeaderMenuModule,
    ProfileModule,
    OverviewModule,
    PaymentModule,
    ProductModule,
    JobModule,
    AvailableJobModule,
    ExpertiseModule,
    CountryModule,
    UploadFileModule,
    FirebaseModule,
  },
});

export default store;
